import { z } from 'zod';
import { DeviceTypeEnum, PageMatchesOpEnum, PageMatchesTypeEnum, DimensionStringTypeEnum, DimensionNameEnum, DimensionContainsEnum, DimensionTimeRangeEnum, DimensionMatchesWithOtherEnum, } from '../types/campaignsJson';
import { config } from '../config';
var makeFilteredSchema = function (s) {
    return z.array(z.any()).transform(function (as) { return as.filter(function (a) { return s.safeParse(a).success; }); });
};
var pageMatchesSchema = z.object({
    match: z.string(),
    type: z.nativeEnum(PageMatchesTypeEnum),
    op: z.nativeEnum(PageMatchesOpEnum).optional(),
});
var dimensionUrlSchema = z.object({
    name: z.literal(DimensionNameEnum.url),
    type: z.nativeEnum(PageMatchesTypeEnum),
    match: z.string(),
});
var dimensionReferrerSchema = z.object({
    name: z.literal(DimensionNameEnum.referrer),
    type: z.nativeEnum(DimensionMatchesWithOtherEnum),
    match: z.string(),
    op: z.nativeEnum(PageMatchesOpEnum).optional(),
});
var dimensionOSSchema = z.object({
    name: z.literal(DimensionNameEnum.os_type),
    type: z.nativeEnum(DimensionContainsEnum),
    match: z.string(),
    op: z.nativeEnum(PageMatchesOpEnum).optional(),
});
var scheduleSchema = z.object({
    start: z.string(),
    end: z.string(),
});
var scheduleStartSchema = z.object({
    start: z.string(),
});
var durationSchema = z.union([
    z.object({
        type: z.literal(DimensionTimeRangeEnum.all),
    }),
    z.object({
        type: z.literal(DimensionTimeRangeEnum.latest),
    }),
    z.object({
        type: z.literal(DimensionTimeRangeEnum.today),
    }),
    z.object({
        type: z.literal(DimensionTimeRangeEnum.past_week),
    }),
    z.object({
        type: z.literal(DimensionTimeRangeEnum.past_month),
    }),
    z.object({
        type: z.literal(DimensionTimeRangeEnum.time_range),
        schedule: scheduleSchema,
    }),
    z.object({
        type: z.literal(DimensionTimeRangeEnum.before),
        schedule: scheduleStartSchema,
    }),
    z.object({
        type: z.literal(DimensionTimeRangeEnum.after),
        schedule: scheduleStartSchema,
    }),
]);
var dimensionNumberOfVisitSchema = z.object({
    name: z.literal(DimensionNameEnum.number_of_visit),
    type: z.nativeEnum(PageMatchesTypeEnum),
    match: z.string(),
    options: z.object({
        duration: durationSchema,
        trigger: z.object({
            visit: z.object({
                total: z.number(),
            }),
        }),
    }),
});
var dimensionTimeOnPageSchema = z.object({
    name: z.literal(DimensionNameEnum.time_on_page),
    type: z.nativeEnum(PageMatchesTypeEnum),
    match: z.string(),
    options: z.object({
        duration: durationSchema,
        trigger: z.object({
            time: z.object({
                spent: z.object({
                    type: z.nativeEnum(DimensionStringTypeEnum),
                    from: z.number(),
                    to: z.number().optional(),
                }),
            }),
        }),
    }),
    op: z.nativeEnum(PageMatchesOpEnum).optional(),
});
var dimensionSchema = z.union([
    dimensionUrlSchema,
    dimensionReferrerSchema,
    dimensionOSSchema,
    dimensionNumberOfVisitSchema,
    dimensionTimeOnPageSchema,
]);
export var campaignJsonSchemaCommon = z.lazy(function () {
    return z.object({
        campaignId: z.string().nonempty(),
        correlationId: z.string().nullable().optional(),
        pageMatches: z.array(z.array(pageMatchesSchema)),
        schedule: z.object({
            start: z.string().datetime({ offset: true }),
            end: z.string().datetime({ offset: true }),
        }),
        device: z.nativeEnum(DeviceTypeEnum),
    });
});
export var campaignJsonSchema = z.lazy(function () {
    return config.env.isDimention
        ? campaignJsonSchemaCommon.and(z.object({
            dimensions: z
                .array(makeFilteredSchema(dimensionSchema))
                .optional()
                .nullable(),
        }))
        : campaignJsonSchemaCommon;
});
